<template>
  <div :class="getClass()">
    <div class="our-work-info__inner">
      <div aria-label="Close" @click="close" class="our-work-info__close">
        <inline-svg :src="require('../../../images/icon-close-red.svg')" />
      </div>
      <div class="our-work-info__inner__content">
        <div
          class="our-work-info__quotes"
          v-if="customer && customer.has_quotes"
        >
          <div
            class="our-work-info__quotes__quote"
            v-for="(quote, index) in customer.quotes"
            :key="index"
          >
            <blockquote
              v-if="quote.quote && quote.display_as_quote"
            >
              <div class="our-work-info__quotes__quote__inner">
                  <p v-html="quote.quote"></p>
              </div>
            </blockquote>
            <p
              v-if="quote.quote && !quote.display_as_quote"
              class="our-work-info__quotes__quote__text"
              v-html="quote.quote"
            ></p>
            <p
              v-if="quote.name && quote.display_as_quote"
              class="our-work-info__quotes__quote__name"
            >
              {{ quote.name }}
            </p>
            <p
              v-if="quote.subtitle && quote.display_as_quote"
              class="our-work-info__quotes__quote__title"
            >
              {{ quote.subtitle }}
            </p>
            <a
              v-if="quote.link"
              :href="quote.link.url"
              :title="quote.link.title"
              :target="quote.link.target"
              class="btn btn-primary our-work-info__quotes__quote__link"
            >
              {{ quote.link.title }}
            </a>
          </div>
        </div>
        <div v-else class="our-work-info__inner__content__space"></div>
        <div
          :class="
            `our-work-info__services` + !customer.has_quotes
              ? ' our-work-info__services--no-quotes'
              : ''
          "
          v-if="customer && customer.services"
        >
          <p class="our-work-info__services__title">Services</p>
          <ul class="our-work-info__services__links">
            <li
              v-for="(service, service_index) in customer.services"
              :key="service_index"
            >
              <inline-svg :src="service.icon.url" />
              <a
                v-if="service.link"
                :href="service.link.url"
                :title="service.link.title"
                :target="service.link.target"
              >
                {{ service.link.title }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurWorkInfo",
  props: {
    customer: {
      default: null
    },
    active_customer_index: {
      default: 0
    },
    row_number: {},
    is_mobile: {
      default: false
    },
    index: {}
  },
  computed: {
    /**
     * Get the active row number
     * @returns {number}
     */
    active_row() {
      if (this.active_customer_index === null) {
        return -1;
      } else {
        let active_row_number = Math.floor(
          this.active_customer_index / (this.is_mobile ? 2 : 4)
        );
        return active_row_number;
      }
    },
    is_active() {
      return this.active_row === this.row_number;
    }
  },
  methods: {
    getClass() {
      let className = "our-work-info";
      if (this.is_active) {
        className += " our-work-info--active";
      }
      if (this.is_mobile) {
        className += " our-work-info--mobile";
      }
      return className;
    },
    close() {
      this.active_customer_index = null;
      document
        .querySelector(".our-work__customers__customer--active")
        .classList.remove("our-work__customers__customer--active");
    }
  }
};
</script>

<style scoped lang="scss">
.our-work-info {
  max-height: 0;
  height: auto;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out, padding-top 0.3s ease-in-out,
    opacity 0.1s ease-in-out;
  width: 100%;
  opacity: 0;
  margin-top: -32px;
  z-index: 2;
  position: relative;

  @media only screen and (max-width: 768px) {
    display: none;
  }

  &--mobile {
    display: none;
    @media only screen and (max-width: 768px) {
      display: block;
    }
  }

  &--active {
    max-height: 1000px;
    opacity: 1;

    @media only screen and (max-width: 768px) {
      max-height: initial;
    }
  }

  &__close {
    position: absolute;
    top: 30px;
    right: 14px;
    width: 45px;
    height: 45px;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0;
    cursor: pointer;
  }

  &__inner {
    height: 100%;
    overflow: hidden;
    padding: 32px 15px;

    &__content {
      padding: 36px 44px;
      background-color: white;
      box-shadow: 0px 0 16px 0px rgba(0, 0, 0, 0.16);
      overflow: hidden;
      /*height: 100%;*/
      display: flex;

      @media only screen and (max-width: 768px) {
        padding: 24px 24px;
        display: block;
      }

      &__space {
        /*height: 500px;*/
      }
    }
  }

  &__quotes {
    flex: 0 0 75%;
    margin-left: 14px;
    padding-right: 53px;

    @media only screen and (max-width: 768px) {
      width: 100%;
      border: 0px;
      padding: 24px 24px 24px 0;
    }

    &__quote {
      padding-bottom: 36px;

      &:last-child {
        padding-bottom: 0;
      }

        &__inner {
            p {
                position: relative;
                display: inline;

                &:after {
                    content: "”";
                    width: 14px;
                    font-size: 24px;
                }
            }
        }

      blockquote,
      &__text {
        font-family: "Open Sans";
        font-weight: 300;
        font-style: italic;
        font-size: 24px;
        line-height: 30px;
        position: relative;

        @media only screen and (max-width: 768px) {
          font-size: 18px;
          line-height: 24px;
        }

        &:before {
          content: "“";
          position: absolute;
          width: 14px;
          left: -14px;
        }
      }

      &__text {
        &:before {
          display: none;
        }
      }

      &__name {
        font-size: 14px;
        line-height: 20px;
        font-weight: bold;
        color: #323232;
      }

      &__title {
        font-size: 14px;
        line-height: 20px;
        color: #323232;
      }

      &__link {
        margin-top: 18px;
      }
    }
  }

  &__services {
    flex: 0 0 25%;
    padding-left: 32px;
    border-left: 1px solid #dcdcdc;

    &--no-quotes {
      border: 0px;
      margin: 0 auto;
    }

    &__title {
      font-size: 12px;
      line-height: 14px;
      font-weight: bold;
      text-transform: uppercase;
      color: #323232;
      margin-bottom: 27px;
    }

    &__links {
      margin-bottom: 24px;

      li {
        display: flex;
        align-items: center;
        margin-bottom: 14px;

        svg {
          flex-basis: 44px;
          margin-right: 18px;
        }

        a {
          flex-basis: auto;
          font-size: 12px;
          line-height: 14px;
          color: #dc281e;
          text-transform: uppercase;
          font-weight: 700;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
